import { QueryClientProvider } from '@tanstack/react-query'
import { createBrowserRouter } from 'react-router'
import { RouterProvider } from 'react-router/dom'
import { queryClient } from '../api/queryClient'
import { SessionProvider } from '../session/SessionProvider'
import { routes } from './routes'

/** One browser router for the app, inside the server-data cache and the session. Routes are in routes.tsx. */
const router = createBrowserRouter(routes)

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <RouterProvider router={router} />
      </SessionProvider>
    </QueryClientProvider>
  )
}
